import React from 'react';
import Page from 'src/components/Page';
import url from 'src/util/url';
import { HashLink as Link } from 'react-router-hash-link';
import routes from 'src/routes';
import CodeSamples from 'src/components/CodeSamples';

const SampleSteps = {
    OpenAPIGenerator: 0,
    WindowDownload: 1,
    MacLinuxDownload: 2,
    GenerateClientLib: 3,
}

const SampleStepsDoco =
    [
        {             
            step: "Step 1 - Download OpenAPI Generator",
            description: <p>Create a directory on your local computer and download OpenAPI Generator.  You may wish to visit <a href="https://openapi-generator.tech/docs/installation/" target="_blank" rel="noopener noreferrer">OpenApi</a> for the latest Generator.</p>,
        },

        {           
            description: "For Windows.  Run in PowerShell:",
            language: 'powershell',
            code: `
Invoke-WebRequest -OutFile openapi-generator-cli.jar https://repo1.maven.org/maven2/org/openapitools/openapi-generator-cli/6.6.0/openapi-generator-cli-6.6.0.jar
            `
        },

        {
            description: "For Mac/Linux run:",                        
            language: 'CMD',
            code: `
wget https://repo1.maven.org/maven2/org/openapitools/openapi-generator-cli/6.6.0/openapi-generator-cli-6.6.0.jar -O openapi-generator-cli.jar
            `
        },

        {             
            step: "Step 2 - Generate RESTful client library",
            description: "Run command to generate client library.  Make sure you have a version of Java installed.",
            language: 'CMD',
            code: `
java -jar openapi-generator-cli.jar generate -i ${url.api("v5/swagger")} -g csharp-netcore -o "ClientLib" -p packageName=BpointQuickStart.ClientLib --additional-properties=targetFramework=net6.0
            `
        },
    ];


const OpenAPIGenerator = () => {


    const codeSnippetStep = (stepIdx) => {
                
        return (<div>
            { SampleStepsDoco[stepIdx]?.step && <h3>{SampleStepsDoco[stepIdx]?.step}</h3> }
            { SampleStepsDoco[stepIdx]?.description && <p>{SampleStepsDoco[stepIdx]?.description}</p> }
            { SampleStepsDoco[stepIdx]?.DocoUrl && <p>API Reference <Link to={routes.api.spec + SampleStepsDoco[stepIdx]?.DocoUrl}>{SampleStepsDoco[stepIdx]?.DocoComment}</Link></p>}
            { SampleStepsDoco[stepIdx]?.language && <CodeSamples samples={[
                {
                    language: SampleStepsDoco[stepIdx].language,
                    content: SampleStepsDoco[stepIdx].code
                }
            ]} copyButton /> }
        </div>);

    }

    return (<Page header="Downloading OpenAPI Generator and Generating BPoint RESTful libraries">
        <p>
            Generating the RESTful client using OpenAPI Generator will help in calling BPoint APIs.  Follow the steps below to download and generate the  client library.
        </p>

        { codeSnippetStep(SampleSteps.OpenAPIGenerator) }
        { codeSnippetStep(SampleSteps.WindowDownload) }
        { codeSnippetStep(SampleSteps.MacLinuxDownload) } 
        { codeSnippetStep(SampleSteps.GenerateClientLib) } 

        <p>
            You are now ready to connect to API BPoint via client library.  You can follow the <Link to={routes.getstarted.quickstart}>QuickStart</Link> guide to become familiar with the API.
        </p>
        
    </Page>);
}

export default OpenAPIGenerator;